import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import VerifiedIcon from '@mui/icons-material/Verified';
import Avatar from '@mui/material/Avatar';
import SettingAction from '../../store/actions/SettingAction';
import Loader from '../../utils/errorPages/Loader';
import LinkExpired from '../../utils/errorPages/LinkExpired';

function VerifyEmail() {
  const dispatch = useDispatch();
  const { code } = useParams();

  useEffect(() => {
    dispatch(SettingAction.getVerifyMail(code));
  }, [dispatch, code]);

  const { isLoading, mailVerifyData } = useSelector((state) => state.setting);

  if (mailVerifyData === true) {
    return (
      <div>
        {isLoading === true ? <Loader /> : false}
        <div className="auth loginbox main-content my-5">
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
              background: '#fafafa',
              '& > :not(style)': {
                m: 1,
                // border: "1px solid #E5E5E5",
                boxShadow: '0px 4px 29px 0px rgba(0, 1, 1, 0.15)',
                borderRadius: '75px 0 75px'
              }
            }}
          >
            <Box
              sx={{
                m: 1,
                background: '#fff',
                width: 495,
                padding: '44px 50px 44px 44px',
                textAlign: 'center'
              }}
            >
              <Paper elevation={0}>
                <Avatar
                  sx={{
                    justifyContent: 'center',
                    margin: '0  auto 20px',
                    width: 65,
                    height: 65,
                    bgcolor: 'primary.main'
                  }}
                >
                  <VerifiedIcon />
                </Avatar>
                <Typography
                  variant="h3"
                  gutterBottom
                  component="h3"
                  mb={1}
                  sx={{
                    fontSize: '30px',
                    fontWeight: 'bold'
                  }}
                >
                  Link Verified
                </Typography>
                <Typography variant="subtitle1" gutterBottom component="" mb={1}>
                  Your email has changed successfully
                </Typography>
                <Button
                  className="btn submit_btn"
                  variant="contained"
                  component={Link}
                  color="primary"
                  to="/"
                  sx={{ marginTop: '15px!important' }}
                  size="medium"
                >
                  Back to Sign In
                </Button>
              </Paper>
            </Box>
          </Box>
        </div>
      </div>
    );
  }
  return (
    <div>
      {isLoading === true ? <Loader /> : false}
      <LinkExpired />
    </div>
  );
}
export default VerifyEmail;
